import { useContext, useState } from "react";
import { IconButton, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, Tooltip, Zoom } from "@mui/material";
import { IUser, usersContext } from '../UsersContext';
import { DeleteIconButton, EditIconButton } from "components";
import { applicationContext, appUserContext } from "helpers/services";
import { MdVpnKey, MdRestore } from "react-icons/md";
import { FaRegCheckCircle } from "react-icons/fa";
import { FaRegHandshake } from "react-icons/fa";
import { BiMailSend as ResendEmailIcon } from 'react-icons/bi';
import { useIntl } from "react-intl";
import { LocalizationIds } from 'helpers/Localizations';
import CanGoToCustomerEdit from './CanGoToCustomerEdit';

let Results = () => {
    let { userGroups } = useContext(applicationContext);
    let { currentUser } = useContext(appUserContext);
    let { formatMessage } = useIntl();

    let service = useContext(usersContext);

    let [canGoToCustomerUser, setCanGoToCustomerUser] = useState<IUser | null>(null);

    let closeCanGoToCustomerEdit = (refreshData: boolean) => {
        setCanGoToCustomerUser(null);
        if (refreshData === true) {
            service.doSearch({ ...service.search });
        }
    }

    return (
        <>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Nome</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell align="center">Pu&ograve; andare da cliente</TableCell>
                        <TableCell>Gruppi</TableCell>
                        <TableCell />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {service.users.map((user, index) =>
                        <TableRow hover key={index}>
                            <TableCell>{user.fullName}</TableCell>
                            <TableCell>{user.email}</TableCell>
                            <TableCell align="center">
                                {user.canGoToCustomer === true && <FaRegCheckCircle />}
                            </TableCell>
                            <TableCell>{userGroups.filter(x => user.groups?.indexOf(x.key) !== -1).map(x => x.value).join(", ")}</TableCell>
                            <TableCell align="right">
                                {user.isDeleted === false &&
                                    <>
                                        {(currentUser?.simecClaims?.canManageCanGoToCustomerSimecUsers === true || currentUser?.simecClaims?.canManageSimecUsers === true) &&
                                            <Tooltip title={formatMessage({ id: LocalizationIds.EditCanGoToCustomer })} TransitionComponent={Zoom}>
                                                <IconButton
                                                    size="small"
                                                    color="secondary"
                                                    onClick={(ev: any) => setCanGoToCustomerUser(user)}
                                                >
                                                    <FaRegHandshake />
                                                </IconButton>
                                            </Tooltip>
                                        }
                                        <Tooltip title={formatMessage({ id: LocalizationIds.ResendEmailInvitation })} TransitionComponent={Zoom}>
                                            <IconButton
                                                size="small"
                                                color="secondary"
                                                onClick={async (ev) => {
                                                    ev.stopPropagation();
                                                    await service.reSendEmail(user.email);
                                                }}
                                            >
                                                <ResendEmailIcon />
                                            </IconButton>
                                        </Tooltip>
                                        {currentUser?.simecClaims?.canManageSimecUsers === true &&
                                            <>
                                                {user.canDoLoginAs && currentUser?.simecClaims?.canLoginAs === true &&
                                                    <Tooltip title={formatMessage({ id: LocalizationIds.LoginAs })} TransitionComponent={Zoom}>
                                                        <IconButton
                                                            size="small"
                                                            color="secondary"
                                                            onClick={(ev: any) => service.loginAs(user.email)}
                                                        >

                                                            <MdVpnKey />
                                                        </IconButton>
                                                    </Tooltip>
                                                }
                                                <EditIconButton link={`/user/edit/${user.id}`} />
                                                <DeleteIconButton onClick={() => service.deleteUser(user.id)} />
                                            </>
                                        }
                                    </>
                                }
                                {user.isDeleted === true && currentUser?.simecClaims?.canManageSimecUsers === true &&
                                    <Tooltip title={formatMessage({ id: LocalizationIds.RestoreUser })} TransitionComponent={Zoom}>
                                        <IconButton
                                            size="small"
                                            color="secondary"
                                            onClick={(ev: any) => service.restoreUser(user.id)}
                                        >
                                            <MdRestore />
                                        </IconButton>
                                    </Tooltip>
                                }
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                {service.users.length === 0 &&
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={5}><i>No users were found</i></TableCell>
                        </TableRow>
                    </TableFooter>
                }
            </Table>
            <TablePagination
                component="div"
                count={service.recordCount}
                onPageChange={(e, pageNr) => service.handleChangePage(pageNr)}
                page={service.search.pageNr}
                rowsPerPage={service.search.pageSize}
                rowsPerPageOptions={[service.search.pageSize]}
                labelDisplayedRows={({ page, count }) =>
                    <>
                        Total users:&nbsp;{count} &nbsp;&middot;&nbsp;
                        <span>Page {page + 1} di {Math.ceil(count / service.search.pageSize)}</span>
                    </>
                }
            />

            {canGoToCustomerUser != null && canGoToCustomerUser.id != null &&
                <CanGoToCustomerEdit
                    email={canGoToCustomerUser.email}
                    userId={canGoToCustomerUser.id}
                    canGoToCustomer={canGoToCustomerUser.canGoToCustomer}

                    onClose={(refreshData: boolean) => closeCanGoToCustomerEdit(refreshData)}
                />
            }
        </>
    )
}

export default Results;